const styles = (theme) => ({
  productDetails: {
    width: '65%',
  },
  field: {
    fontSize: 14,
    color: theme.color.black_80,
  },
  statusField: {
    paddingTop: theme.spacing(1),
  },
  trackingNumber: {
    color: theme.color.teal,
  },
  trackingLink: {
    fontSize: 14,
    color: theme.color.teal,
  },
  controls: {
    marginTop: theme.spacing(1),
    width: 130,
    height: 40,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 300,
    border: `1px solid ${theme.color.grey_medium}`,

    '& button': {
      padding: 0,
      height: 40,
      width: 40,
    },

    '& .Mui-disabled': {
      opacity: 0.5,
    },
  },
  fulfillmentText: {
    paddingBottom: theme.spacing(1),
  },
  deliveryDateSelector: {
    paddingTop: theme.spacing(2),
  },
  prodNameBlack: {
    '& a:link': { color: theme.color.black_80 },
  },
});

export default styles;
